import { Navigate, useParams } from "react-router-dom";
import { Loader, Logo, useAPI } from "@/components/lib";
import scheduleImage from "@/images/game_schedule_image.jpg";
import Game from "./game";

export default function Season() {
  const { season } = useParams<{ season: string }>();
  const { data, loading } = useAPI(`/api/schedule?season=${season}`);

  if (season !== "fall" && season !== "spring") {
    return <Navigate to="/404" replace />;
  }

  const seasonTittle = season === "fall" ? "Fall" : "Spring";

  return (
    <main className="flex flex-col text-center text-white">
      <Logo className="w-48 lg:w-64 mx-auto my-5 sm:mt-0 lg:hidden" />
      <div className="relative w-full overflow-hidden shadow-lg pb-4">
        <img
          src={scheduleImage}
          alt="Grapevine High School"
          className="w-full hidden lg:block lg:h-[90vh] opacity-10"
        />

        <div
          className="hidden lg:block absolute inset-0"
          style={{
            background:
              "linear-gradient(to left, rgba(7, 16, 27, 0) 10%, #07101B 50%)"
          }}
        />

        <div className="lg:absolute lg:top-0 lg:mt-2 lg:left-1/2 lg:-translate-x-1/2 p-4 md:px-8 text-white w-full">
          <p className="font-bold text-2xl lg:text-5xl">Grapevine High School</p>
          <p className="font-bold mt-2 text-xl lg:text-4xl">
            {seasonTittle} Schedules
          </p>
          <div className="mt-10 flex flex-col gap-3 h-[60vh] overflow-y-scroll md:w-4/5 lg:w-1/2 mx-auto">
            {loading ? (
              <div className="flex justify-center items-center py-10">
                <Loader />
              </div>
            ) : (
              <>
                {data?.length > 0 ? (
                  data.map((game: any) => <Game key={game.id} {...game} />)
                ) : (
                  <p className="text-center text-2xl">No Games Scheduled</p>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
